import type { Phone } from "@tandemdiabetes/sugarmate-api-react-client"
import { useCreatePhoneWithAccessToken as useCreatePhoneWithAccessTokenAPI } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import { noticeError } from "src/utils"

export function useCreatePhoneWithAccessToken() {
  const createPhone = useCreatePhoneWithAccessTokenAPI()

  return useMemo(
    () => !createPhone
      ? undefined
      : async (
        phone: Partial<Phone>,
        accessToken: string,
      ) => {
        try {
          const response = await createPhone(
            phone,
            accessToken,
          )
          return response
        } catch (e) {
          noticeError(
            e,
            "CreatePhone",
            { phone },
          )

          throw e
        }
      },
    [createPhone],
  )
}
